
























import Vue from "vue";

export default Vue.extend({
  name: "Account",
  props: {
    source: String,
  },
});
